import { useEffect, useState } from "react";
import { PATHS } from "../../config/permissionsPaths";
import useAuth from "../../hooks/useAuth";
import { FaSearch, FaUpload, FaEye, FaDownload } from "react-icons/fa";
import { BtnGeneral } from "../../styles/Buttons";
import UploadDocumentModal from "../../components/Modals/UploadDocumentModal";
import useBaseDocumental from "../../hooks/baseDocumental/useBaseDocumental";
import {
  Sidebar,
  MainContent,
  SearchBar,
  Input,
  CheckboxGroup,
  SubCheckboxGroup,
  ButtonGroup,
  CardsWrapper,
  Card,
  PdfThumbnail,
  Title,
  Metadata,
} from "./BaseDocumental.styles";

export default function BaseDocumental() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const hook = useBaseDocumental();

  const {
    categorias,
    loadCategorias,
    keyword,
    setKeyword,
    documentos,
    fetchDocumentos,
    tiposSeleccionados,
    toggleTipo,
    isGroupSelected,
    handleParentToggle,
    handleViewPDF,
    handleDownloadPDF,
  } = hook;

  const { hasPermission } = useAuth();

  useEffect(() => {
    loadCategorias();
  }, []);

  useEffect(() => {
    fetchDocumentos();
  }, [keyword, tiposSeleccionados]);

  return (
    <div className="div-container">
      <Sidebar>
        <h3>Filtrar por tipo</h3>
        <CheckboxGroup>
          {Object.entries(categorias).map(([categoria, subtipos]) => (
            <div key={categoria}>
              <label>
                <input
                  type="checkbox"
                  checked={isGroupSelected(subtipos)}
                  onChange={() => handleParentToggle(subtipos)}
                />{" "}
                {categoria}
              </label>

              <SubCheckboxGroup>
                {subtipos.map((sub) => (
                  <label key={sub.id}>
                    <input
                      type="checkbox"
                      checked={tiposSeleccionados.includes(sub.id)}
                      onChange={() => toggleTipo(sub.id)}
                    />{" "}
                    {sub.nombre}
                  </label>
                ))}
              </SubCheckboxGroup>
            </div>
          ))}
        </CheckboxGroup>
      </Sidebar>

      <MainContent>
        <SearchBar>
          <Input
            placeholder="Buscar por palabra clave..."
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
          />
          <BtnGeneral bg="blue" padding="12px" radius="0 8px 8px 0" flex="0">
            <FaSearch />
          </BtnGeneral>
          {hasPermission(PATHS.CARGAR_DOCUMENTOS) && (
            <BtnGeneral bg="green" mgl="10px" onClick={() => setIsModalOpen(true)}>
              <FaUpload /> Subir Documento
            </BtnGeneral>
          )}
        </SearchBar>

        <CardsWrapper>
          {documentos.length === 0 ? (
            <p>No se encontraron documentos</p>
          ) : (
            documentos.map((doc) => (
              <Card key={doc.id}>
                <PdfThumbnail />
                <Title>{doc.titulo}</Title>
                <Metadata> Fecha: {new Date(doc.fecha_subida).toLocaleDateString()}</Metadata>
                <Metadata>Tipo: {doc.tipoDescripcion}</Metadata>
                {/* <Metadata>Palabras clave: {doc.palabras_clave}</Metadata> */}
                <ButtonGroup>
                  {hasPermission(PATHS.VER_DOCUMENTOS) && (
                    <BtnGeneral bg="blue" flex="4" padding="7px" onClick={() => handleViewPDF(doc.ruta_archivo)} >
                      <FaEye /> Ver
                    </BtnGeneral>
                  )}
                  {hasPermission(PATHS.DESCARGAR_DOCUMENTOS) && (
                    <BtnGeneral bg="green" flex="4" padding="7px" onClick={() => handleDownloadPDF(doc.ruta_archivo, doc.nombre_archivo) }>
                      <FaDownload /> Descargar
                    </BtnGeneral>
                  )}
                </ButtonGroup>
              </Card>
            ))
          )}
        </CardsWrapper>

        <UploadDocumentModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          hook={hook}
        />
      </MainContent>
    </div>
  );
}
